var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type != "history"
    ? _c("div", { staticClass: "order_cnt" }, [
        _c("div", { on: { click: _vm.countDown } }, [
          _c("div", { staticClass: "op_minus" })
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.count,
              expression: "count",
              modifiers: { number: true }
            }
          ],
          attrs: { type: "text", maxlength: "2" },
          domProps: { value: _vm.count },
          on: {
            keypress: _vm.validateNumber,
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.count = _vm._n($event.target.value)
              },
              function($event) {
                _vm.count = _vm.inputRestNumber($event)
              }
            ],
            blur: [
              _vm.onBlurProductCount,
              function($event) {
                _vm.$forceUpdate()
              }
            ]
          }
        }),
        _vm._v(" "),
        _c("div", { on: { click: _vm.countUp } }, [
          _c("div", { staticClass: "op_plus" })
        ])
      ])
    : _c("div", [_c("span", [_vm._v("商品個数 : " + _vm._s(_vm.count))])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fef326e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fef326e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/components/common/DcCounter.vue
// module id = null
// module chunks = 